exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left-align{text-align:left}.center-align{text-align:center}.right-align>div{justify-content:flex-end!important}.calendar-header{position:fixed;top:52px;left:0;right:0;z-index:30;background-color:#fff;padding:8px 0}#calendar{position:absolute;top:104px;left:0;right:0}#calendar .fc-head{position:fixed;top:104px;left:0;right:0;z-index:30;background-color:#fff}#calendar .fc-body{position:absolute;top:26px}#calendar .list-resource{margin-left:.3rem;font-size:.8rem;color:rgba(74,74,74,.8)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-310722be","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calendar.vue
// module id = 228
// module chunks = 1